import React from "react";
import styles from "./PageHeader.module.scss";

const PageHeader = (props) => {
  return (
    <div>
      <div className={`${styles.pageHeader} ${props.className}`}>
        <div className={styles.pageHeaderText}>{props.title}</div>
      </div>
    </div>
  );
};

export default PageHeader;
